/**
 * Helpers partagés des plannings ventes KKP (formatage / ids / périodes).
 */

export const getPlanningVenteRowId = (vente) => vente?.id ?? vente?.slot_key;

export const formatAudience = (value) => {
  if (value == null || value === '') return '—';
  if (typeof value === 'number') {
    return new Intl.NumberFormat('fr-FR').format(value);
  }
  const num = Number(String(value).replace(/\s/g, '').replace(',', '.'));
  if (Number.isFinite(num) && String(value).trim() !== '') {
    return new Intl.NumberFormat('fr-FR').format(num);
  }
  return value;
};

/**
 * Parse un taux de clic (0,1372 / 13,72 / 13.72% / 13,72 %) vers un pourcentage.
 * La virgule française est le séparateur décimal — elle n’est pas un millier.
 */
export const parseTauxClickNumber = (value) => {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (!raw || raw.startsWith('#')) return null;
  const hasPercent = raw.includes('%');
  const num = Number(raw.replace(/%/g, '').replace(/\s/g, '').replace(',', '.'));
  if (!Number.isFinite(num)) return null;
  if (!hasPercent && num <= 1) return num * 100;
  return num;
};

/** Affichage type « 13,72 % » (locale fr-FR). */
export const formatTauxClick = (value) => {
  const num = parseTauxClickNumber(value);
  if (num == null) {
    if (value == null || value === '') return '—';
    const raw = String(value).trim();
    if (raw.startsWith('#')) return '—';
    return raw;
  }
  return `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num)} %`;
};

export const todayYmd = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const periodFromDateDebut = (dateDebut) => {
  if (!dateDebut || typeof dateDebut !== 'string') {
    const now = new Date();
    return { annee: now.getFullYear(), mois: now.getMonth() + 1 };
  }
  const [y, m] = dateDebut.split('-').map(Number);
  return {
    annee: Number.isFinite(y) ? y : new Date().getFullYear(),
    mois: Number.isFinite(m) ? m : new Date().getMonth() + 1,
  };
};

/** Label « Mois Année » depuis filtres annee/mois (multi → single). */
export const importPeriodLabelFromYearMonth = (anneeVal, moisVal, moisOptions = []) => {
  if (!anneeVal || !moisVal) return '';
  const moisOpt = moisOptions.find((option) => String(option.value) === String(moisVal));
  return `${moisOpt?.label ?? moisVal} ${anneeVal}`;
};

/** Label période depuis date_debut YYYY-MM-DD. */
export const importPeriodLabelFromDateDebut = (dateDebut, moisOptions = []) => {
  const { annee, mois } = periodFromDateDebut(dateDebut);
  return importPeriodLabelFromYearMonth(annee, mois, moisOptions);
};
